import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { internalChatEndpoint } from "@/config/endpoints";

export interface MentionableUser {
  id: number;
  name: string;
  /** The person's role name ("Counsellor", "Regional Operation Head"). */
  role: string;
  /** Holds the lead or one of its deals — listed first. */
  isAssigned?: boolean;
}

/**
 * Who can be @mentioned in this chat: everyone who can SEE the lead (deal
 * chat: the deal) — admins, assigned users, branch managers, CF / track
 * access holders (server: GET /internal-chat/:leadId/mentionable, the shared
 * lead-audience rule). An older server has no such route, so it falls back to
 * the members list the composer used before.
 */
export function useMentionableUsers(leadId: number | string | null, childId: number | null) {
  const query = useQuery<MentionableUser[]>({
    queryKey: ["chat-mentionable", String(leadId), childId ?? "all"],
    queryFn: async () => {
      try {
        const res = await axiosInstance.get(`${internalChatEndpoint}/${leadId}/mentionable`, {
          params: childId ? { childId } : undefined,
        });
        return res.data?.users || [];
      } catch {
        const res = await axiosInstance.get(`${internalChatEndpoint}/${leadId}/members`);
        return res.data?.members || [];
      }
    },
    enabled: Boolean(leadId),
    staleTime: 1000 * 60 * 2,
  });
  return { users: query.data || [], isLoading: query.isLoading };
}
